const PAYMENT_TYPE = Object.freeze({
  cash: 'cash',
  card: 'card',
  onlineCard: 'online_card',
  slickPos: 'slick_pos',
});

// noinspection JSUnusedGlobalSymbols
export default PAYMENT_TYPE;
